import React from "react";
import { array, object } from "prop-types";
import { Link } from "react-router-dom";
import moment from "moment";

import Header from "./Header";
import CampaignStatus from "./CampaignStatus";
import Restricted from "./Restricted";

const CampaignList = ({ campaigns, activeAccount }) => {
  return (
    <div>
      <Header
        title="Lista de campanhas"
        button={{ title: "Criar nova campanha", link: "/campaigns/add" }}
      />
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <table className="table-campaigns table table-striped table-hover">
              <thead>
                <tr>
                  <th>Criada em</th>
                  <th>Nome da campanha</th>
                  <th className="text-center">Quantidade de videos</th>
                  <Restricted accepted={["overmedia", "itau", "admin"]}>
                    <th className="text-center">Status</th>
                  </Restricted>
                  <th className="text-right">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {campaigns &&
                  campaigns.map((campaign, index) => (
                    <tr key={index}>
                      <td>
                        {(campaign.videos[0] &&
                          campaign.videos[0].created_at &&
                          moment(campaign.videos[0].created_at).format(
                            "DD/MM/YYYY"
                          )) ||
                          "-"}
                      </td>
                      <td>
                        <Link to={`/campaigns/${campaign.id}/videos`}>
                          {campaign.name}
                        </Link>
                      </td>
                      <td className="text-center">
                        <Link to={`/campaigns/${campaign.id}/videos`}>
                          {campaign.videos && campaign.videos.length > 1
                            ? `${campaign.videos.length} videos`
                            : `${campaign.videos.length} video`}
                        </Link>
                      </td>
                      <Restricted accepted={["overmedia", "itau", "admin"]}>
                        <td className="text-center">
                          <CampaignStatus campaign={campaign} />
                        </td>
                      </Restricted>
                      <td className="text-right">
                        <Link to={`/campaigns/${campaign.id}/stats`}>
                          <button className="btn btn-sm btn-primary">
                            ver estatísticas
                          </button>
                        </Link>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

CampaignList.propTypes = {
  activeAccount: object,
  campaigns: array
};

export default CampaignList;



// WEBPACK FOOTER //
// ./src/components/CampaignList.js